import React, { useEffect, useState } from "react";
import "./CryptoTicker.css";

const CryptoTicker = () => {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Combined all requested coins (no duplicates)
        const res = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin,ethereum,solana,binancecoin,ripple,toncoin,dogecoin,cardano,tron,avalanche-2,sui,astar,bonk,tether,pepe&order=market_cap_desc"
        );
        const data = await res.json();
        setCoins(data);
      } catch (error) {
        console.error("Error fetching crypto data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 60000); // refresh every 1 minute
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="crypto-ticker">
      <div className="crypto-scroll">
        {coins.map((coin) => (
          <div key={coin.id} className="crypto-item">
            <img src={coin.image} alt={coin.name} />
            <span className="coin-name">{coin.symbol.toUpperCase()}</span>
            <span className="coin-price">
              ${coin.current_price.toLocaleString()}
            </span>
            <span
              className={`coin-change ${
                coin.price_change_percentage_24h >= 0 ? "positive" : "negative"
              }`}
            >
              {coin.price_change_percentage_24h?.toFixed(2)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CryptoTicker;
